export default __webpack_public_path__ + "media/zurb/img/home/university-oregon-859f78d2be6958e58a78d059068558b1.webp";